import React, { useEffect, useState, useRef, useContext } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import API_BASE_URL from "../Config";
import { LocationContext } from "../components/LocationContext";

function Home() {
  console.log("Home component rendered");

  const outletContext = useOutletContext();
  if (!outletContext) {
    throw new Error("Home must be used inside MainLayout");
  }
  const { posts, setPosts, loading, setLoading } = outletContext;

  const [locationError, setLocationError] = useState("");
  const [locationStatus, setLocationStatus] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [postDetails, setPostDetails] = useState(null);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(true);

  const navigate = useNavigate();

  const hasFetched = useRef(false);
  // const { location, status } = useContext(LocationContext) || {};

  const locationContext = useContext(LocationContext);
  if (!locationContext) {
    throw new Error("Home must be wrapped inside LocationProvider");
  }
  const { location, status, errorMessage, address } = locationContext;

 

  useEffect(() => {
    if (!location || hasFetched.current) return;

    hasFetched.current = true;
    fetchPosts(1);
  }, [location]);

  const fetchPosts = (pageNumber) => {
    if (!location) return;

    setLoading(true);

    const requestData = {
      latitude: location.latitude,
      longitude: location.longitude,
      near_by: "True",
      page: pageNumber,
    };

    fetch(`${API_BASE_URL}/api/app-dashboard`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setPosts(pageNumber === 1 ? data.response.posts : prev => [...prev, ...data.response.posts]);
          setHasNext(data.response.has_next);
        }
      })
      .catch(() => setLocationError("Failed to load posts"))
      .finally(() => setLoading(false));
  };



    
    const handleContactClick = async (post) => {
      const token = localStorage.getItem("token");
      if (token == 'undefined' || token == null || token == '') {
        alert("⚠️ Please login first to see post details.");
        navigate("/login", { error: "Please login first to see post details." } );
        return; // stop here if not logged in
      }
      console.log(token);

      setSelectedPost(post);
      setLoading(true);
      setError("");
      setPostDetails(null);

      try {
          const response = await fetch(`${API_BASE_URL}/api/dashboard-post-detail`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ post_id: post.id }),
          });
          const data = await response.json();
          console.log(data);
          if (data.status === 1) {
              setPostDetails(data.response);
              setShowModal(true);
          } else {
              setError(data.error || "Failed to load details");
          }
      } catch (err) {
          setError("Something went wrong");
          console.error(err);
      } finally {
          setLoading(false);
      }
    };

  const handleDirectionClick = async (postDetails) => {
    if (!postDetails) return;

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;

          const postLat = postDetails.latitude;
          const postLng = postDetails.longitude;

          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${postLat},${postLng}&travelmode=driving`;

          // Open in new tab
          window.open(googleMapsUrl, "_blank");
        },
        () => {
          alert("Unable to get your location");
        }
      );
    } else {
      alert("Geolocation not supported");
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>{locationStatus}</p>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px", color: "red" }}>
        {errorMessage}
      </div>
    );
  }

  return (
    <div>
       <div className="home_three_container">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="blog_wrapper blog_wrapper_details">
            <div className="comments_box">
              <div className="section_title mb-1 mt-5">
                    <p>Nearby</p>
                    <h2>Posts</h2>
                </div>

              <div className="row">
                {posts.length > 0 ? (
                  posts.map((post) => (
                    <div key={post.id} className="col-lg-4 pb-3">
                      {post.custom_user}
                      <div className="comment_list">
                        <div className="comment_thumb">
                          {post.gender === "male" ? (
                            <img
                              src="assets/images/boy.jpg"
                              alt="male"
                              style={{ width: 50, height: 50 }}
                            />
                          ) : post.gender === "female" ? (
                            <img
                              src="assets/images/girl.png"
                              alt="female"
                              style={{ width: 50, height: 50 }}
                            />
                          ) : (
                            <img
                              src="assets/images/company.jpg"
                              alt="company"
                              style={{ width: 50, height: 50 }}
                            />
                          )}
                        </div>
                        <div className="comment_content">
                          <div className="comment_meta">
                            <h5>
                              <a href="#">{post.name}</a>
                            </h5>
                            <span>
                              {post.time_ago} -{" "}
                              <span>({post.distance} km away)</span>
                            </span>
                          </div>
                          <p className="title">
                            <strong>{post.title}</strong>
                          </p>
                          <p className="description">{post.description}</p>
                          <p className="post_location_row">
                            {post.category} &gt; {post.sub_category}
                          </p>

                          <div className="comment_reply">
                            <button onClick={() => handleContactClick(post)}>
                              <i className="fa fa-eye"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No nearby posts found.</p>
                )}
              </div>

              {hasNext && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <button
                    className="btn btn-primary purple__button"
                    onClick={() => {
                      const nextPage = page + 1;
                      setPage(nextPage);
                      fetchPosts(nextPage);
                    }}
                  >
                    Load More
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>



      {/* Modal */}
      <div className={`modal fade ${showModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Post Details</h5> 
              <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>
            <div className="modal-body">
              {loading && <div className="text-center">Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              {postDetails && (
                <>
                  <h5 className="text-primary">{postDetails.title}</h5>
                  <p className="mb-3" style={{ whiteSpace: "pre-wrap" }}>{postDetails.description}</p>
                  {postDetails.email && <p><strong>Email:</strong> {postDetails.email}</p>}
                  {postDetails.hide_whatsapp ? (
                    <p><strong>WhatsApp:</strong> WhatsApp is hidden</p>
                  ) : (
                    <p><strong>WhatsApp:</strong> {postDetails.whatsapp_number} <a href={`https://wa.me/${postDetails.whatsapp_number}`} target="_blank" rel="noopener noreferrer"><i className="ion-social-whatsapp-outline"></i></a></p> 
                  )}
                </>
              )}
            </div>
            <div>
              { <button className="btn btn-success purple__button" onClick={() => handleDirectionClick(postDetails)}>
                <i className="fa fa-map-marker"></i> Get Directions
              </button> }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
  </div>
  );
}

export default Home;
